export function isSignedIn(state) {
    return !!state.user;
}

export function isAdmin(state) {
    return !!(state.user && state.user.roles && state.user.roles.includes('PartnerAdministrator'));
}

export function userCurrency(state) {
    return state.user && state.user.currency;
}

export function getClientInvitations(state) {
    return state.clientInvitations;
}

export function userName(state) {
    return state.user ? state.user.name : '';
}

export function usernameOrEmail(state) {
    return state.user && (state.user.name ? state.user.name : state.user.email);
}

export function hasInOrOutboundCommission(state) {
    return !!state.commission?.inboundCommission || !!state.commission?.outboundCommission;
}

export function partnerTransactions(state) {
    return state.partnerTransactions;
}

export function partnerTransactionsLoading(state) {
    return state.partnerTransactionsLoading;
}

export function partnerTransactionsTotal(state) {
    return state.partnerTransactionsTotal;
}

export function partnerTransactionsSums(state) {
    return state.partnerTransactionsSums;
}
